import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getDefaultPath, login, refreshSession } from "../auth/auth";

// Paleta baseada no teu print:
// marrom topo: #4b2e23 / bege de fundo: #f7ecd9 / botão âmbar: #f59e0b
const styles = {
  bg: "bg-[#f7ecd9]",
  card: "bg-white/95 border border-[#d9c4a8]/60 rounded-2xl shadow-lg",
  topbar: "bg-[#4b2e23] text-white",
  amberBtn:
    "bg-[#f59e0b] hover:bg-[#d98c07] text-[#4b2e23] font-semibold shadow-sm",
  linkMuted: "text-[#6b5a4b]",
  fieldBorder: "border-[#e6d8c5] focus:border-[#f59e0b] focus:ring-[#f59e0b]/30",
};

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const [user, setUser] = useState("");
  const [pass, setPass] = useState("");
  const [show, setShow] = useState(false);
  const [err, setErr] = useState("");

  React.useEffect(() => {
    refreshSession().then((currentUser) => {
      if (currentUser) navigate(from === "/" ? getDefaultPath(currentUser) : from, { replace: true });
    });
  }, [from, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();
    setErr("");

    try {
      const authenticatedUser = await login(user.trim(), pass);
      if (!authenticatedUser) {
        setErr("Usuário ou senha inválidos.");
        return;
      }
      navigate(from === "/" ? getDefaultPath(authenticatedUser) : from, { replace: true });
    } catch (error) {
      setErr(error?.message || "Não foi possível entrar no sistema.");
    }
  }

  return (
    <div className={`min-h-screen ${styles.bg} flex flex-col`}>
      {/* Topbar */}
      <header className={`${styles.topbar} h-14 flex items-center px-6`}>
        <div className="flex items-center gap-3">
          <div className="w-7 h-7 rounded-md bg-white/10 flex items-center justify-center">
            {/* ícone simples */}
            <span className="text-xl">🍪</span>
          </div>
          <h1 className="font-semibold tracking-wide">Di Brownie Dashboard</h1>
        </div>
      </header>

      {/* Conteúdo */}
      <main className="flex-1 flex items-center justify-center px-4 py-10">
        <div className={`w-full max-w-[420px] p-7 ${styles.card}`}>
          <div className="mb-6">
            <h2 className="text-2xl font-semibold text-[#4b2e23]">
              Entrar
            </h2>
            <p className="text-sm mt-1 text-[#6b5a4b]">
              Acesse para visualizar seus relatórios e campanhas.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="text-sm text-[#6b5a4b]">Usuário</label>
              <input
                type="text"
                autoComplete="username"
                className={`mt-1 w-full rounded-lg border px-3 py-2 outline-none transition focus:ring ${styles.fieldBorder}`}
                placeholder=""
                value={user}
                onChange={(e) => setUser(e.target.value)}
              />
            </div>

            <div>
              <label className="text-sm text-[#6b5a4b]">Senha</label>
              <div className="relative mt-1">
                <input
                  type={show ? "text" : "password"}
                  autoComplete="current-password"
                  className={`w-full rounded-lg border px-3 py-2 pr-10 outline-none transition focus:ring ${styles.fieldBorder}`}
                  placeholder=""
                  value={pass}
                  onChange={(e) => setPass(e.target.value)}
                />
                <button
                  type="button"
                  onClick={() => setShow((s) => !s)}
                  className="absolute inset-y-0 right-2 inline-flex items-center text-sm text-[#6b5a4b]/80 hover:text-[#4b2e23]"
                  aria-label={show ? "Ocultar senha" : "Mostrar senha"}
                >
                  {show ? "Ocultar" : "Mostrar"}
                </button>
              </div>
            </div>

            {err && (
              <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-md px-3 py-2">
                {err}
              </div>
            )}

            <button
              type="submit"
              className={`w-full rounded-lg px-4 py-2.5 ${styles.amberBtn}`}
            >
              Entrar
            </button>

            <p className={`text-xs text-center ${styles.linkMuted}`}>
             Sistema <b>Privado</b> Dibrownie <b>.</b>
            </p>
          </form>
        </div>
      </main>

      <footer className="pb-6 text-center text-xs text-[#6b5a4b]">
        © {new Date().getFullYear()} Di Brownie
      </footer>
    </div>
  );
}
